import type { PlainKey } from '../i18n/t';

type Kind = string;

export function kindLabel(kind: Kind): PlainKey {
  switch (kind) {
    case 'ARTICLE':
      return 'lessons-kind-article';
    case 'VOCABULARY':
      return 'lessons-kind-vocabulary';
    case 'MINI_STORY':
      return 'lessons-kind-mini-story';
    case 'POV':
      return 'lessons-kind-pov';
    case 'AUDIO_ARTICLE':
      return 'lessons-kind-audio-article';
    case 'COMMENTARY':
      return 'lessons-kind-commentary';
    default:
      return 'lessons-kind-other';
  }
}

/** Levels 1, 2, 3 in order, a set with no level last; the server already orders sets within one. */
export function levelGroups<S extends { level: number | null | undefined }>(
  sets: readonly S[],
): { level: number | null; sets: S[] }[] {
  const byLevel = new Map<number | null, S[]>();
  for (const s of sets) {
    const k = s.level ?? null;
    byLevel.set(k, [...(byLevel.get(k) ?? []), s]);
  }
  return [...byLevel.entries()]
    .sort(([a], [b]) => (a ?? Infinity) - (b ?? Infinity))
    .map(([level, grouped]) => ({ level, sets: grouped }));
}
